<ion-header>
  <ion-toolbar color="gallaghergreen">
    <img class="gallagher-logo" src="./assets/images/Gallagher Logo -White Transparent.png" />
  </ion-toolbar>
</ion-header>
<div class="loading-container" *ngIf="!loaded">
  <ion-spinner></ion-spinner>
</div>
<ion-content fullscreen class="scan-page">
  <div class="card">
    <div class="scan-wrapper">
      <div class="scan-container">
        <ion-icon name="camera-outline"></ion-icon>
        <div>
          <h3 style="font-size:16px">Scan Garment Barcode</h3>
          <p class="subtitle">Point your camera at the barcode label</p>
        </div>
      </div>
    </div>
    <ion-button expand="block" class="scan-btn" (click)="startScan()" [hidden]="isScanning" style="margin-top:10px">
      Scan Barcode
    </ion-button>
    <div class="scanner-container" [hidden]="!isScanning">

      <div id="reader"></div>

      <div class="scanner-overlay">
        <!-- <div class="scan-box">
          <div class="scan-line"></div>
        </div> -->
      </div>

    </div>

    <p class="scan-hint" *ngIf="isScanning">
      Align the barcode or QR code inside the frame
    </p>

  </div>
  <div class="divider">
    <span>OR</span>
  </div>

  <div class="card">
    <div class="manual-header">
      <ion-icon name="qr-code-outline"></ion-icon>
      <div>
        <h3>Manual Entry</h3>
        <p>Type the barcode number</p>
      </div>
    </div>

    <ion-item lines="none" class="input-item">
      <ion-input [(ngModel)]="garmentCode" placeholder="Enter barcode number" type="tel" inputmode="numeric"
        pattern="[0-9]*">
      </ion-input>
    </ion-item>

    <ion-button expand="block" fill="outline" class="submit-btn" (click)="getGarmentDetail()">
      Submit
    </ion-button>
  </div>

</ion-content>